export const FIELD_TYPES = [
  { value: 'text', label: 'Text', icon: 'text' },
  { value: 'number', label: 'Number', icon: 'number' },
  { value: 'boolean', label: 'Boolean', icon: 'check' }
];
